import React, { useState, useEffect } from 'react'; 
import Header from'../Component/Header'
import Footer from'../Component/Footer'
import { Link } from 'react-router-dom' 
import { getCircular } from "../Service/Api";
import LazyLoad from 'react-lazyload';
const CBSECircular = () => {
    useEffect(() => {
        document.title = 'CBSE Circular -  St Peters convent School Faridabad Haryana';  
    }, []);  
    const [filterData, setFilteredData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const galleryData = await getCircular();
                console.log("Fetched data:", galleryData); // Debugging log
                setFilteredData(galleryData); 
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();
    }, []);
   
  return (
    <>
    <Header/>
    <div className="innerslide">
    <ul className="breadcrumb">
     <li><Link to="/"> Home</Link> </li> 
      <li>  Academics </li> 
     <li>CBSE Circular </li>
 </ul>
</div>
<div className="innersec">
<div className="container">
     <div className="row">
           <div className="col-lg-12">
              <h1>CBSE Circular  </h1>
         </div>
     </div>
     <div className="row"> 
       {filterData?.length > 0 ? filterData?.filter((item) =>  item.category === "CBSE-Circular").map((item, index) => (
                    
        <div className="col-xl-4 col-lg-6" key={index}> 
        <Link to={`https://webapi.entab.info/api/image/${item?.attachments[0]}`} target="_blank">
            <div class="sample-blk">
              <div>
                   <p> {item.title}</p>
                  <span>{item.date}</span>
              </div> 
              <LazyLoad><img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/> 
              </LazyLoad>
              </div> 
                    </Link>
                </div>
                ))
            : (
                <div className="col-lg-4"> 
                <a href="#" target="_blank"> 
                    <div class="sample-blk">
                    <div>
                        <p> Title</p>
                        <span>DD.MM.YY</span>
                    </div> 
                    <LazyLoad> <img alt="STPCH" src="https://webapi.entab.info/api/image/STPSFH/public/Images/pdf.png" class="img-fluid"/>
                    </LazyLoad>
                    </div> 
                </a>  
            </div>
            )}
       </div>
     </div>
  </div> 
<Footer/>
    </>
  )
}

export default CBSECircular
